import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

type ReplacementProductState = Readonly<{
    replacementProdctResult?: any;
}>;

const initialState: ReplacementProductState = {
    replacementProdctResult: undefined
};

const reducer = {
    "Custom/ReplacementProduct/SetProduct": (draft: Draft<ReplacementProductState>, action: { replacementProdctResult: ReplacementProductState }) => {
        draft.replacementProdctResult = action.replacementProdctResult;
        
    }
};
export default createTypedReducerWithImmer(initialState, reducer);
